import { WOUNDTRACK_COLORS } from '@modules/studio/config/studio-colors.config';
import { closedBrokenLineTool, selectionTool } from '@modules/studio/config/studio-tools.config';
import { defaultAnchorConfig, defaultColorPickerConfig, defaultDrawConfig } from '@modules/studio/config/studio.config';
import { StudioConfig } from '@modules/studio/models/studio-config';
import { StudioType } from '@modules/studio/models/studio-type.enum';
import { Tool } from '@modules/studio/models/tool.enum';

export const woundsizeStudioConfig: StudioConfig = {
  id: StudioType.WOUNDSIZE,
  tools: [selectionTool, closedBrokenLineTool],
  drawConfig: {
    ...defaultDrawConfig,
    color: {
      code: WOUNDTRACK_COLORS.SURFACE,
      name: 'Woundtrack Surface',
    },
  },
  colorPickerConfig: defaultColorPickerConfig,
  interfaceConfig: {
    areShapesDraggable: false,
    showColorPicker: false,
    showToolsPicker: false,
  },
  defaultTool: Tool.DRAW_CLOSED_BROKEN_LINE,
  anchorConfig: {
    ...defaultAnchorConfig,
    radius: 5,
  },
};

export const woundtypeStudioConfig: StudioConfig = {
  id: StudioType.WOUNDTYPE,
  tools: [selectionTool],
  drawConfig: {
    ...defaultDrawConfig,
    color: {
      code: WOUNDTRACK_COLORS.SURFACE,
      name: 'Woundtrack Surface',
    },
  },
  colorPickerConfig: defaultColorPickerConfig,
  interfaceConfig: {
    areShapesDraggable: false,
    showColorPicker: false,
    showToolsPicker: false,
  },
  defaultTool: Tool.SELECT_SHAPE,
  anchorConfig: {
    ...defaultAnchorConfig,
    radius: 5,
  },
};
